export default "__VITE_ASSET__Ct9KOW_z__"